import { Table } from "react-bootstrap";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const UserActivityLogsData = ({ userActivityLoader, userActivity = [] }) => {
  return (
    <>
      <h6 className="fw-bold mb-2">User Activity Logs</h6>
      {userActivityLoader ?
        <div
          className="hstack justify-content-center"
          style={{ height: "calc(100vh - 500px)" }}
        >
          <PageLoader/>
        </div>
        :
         <Table className="m-0 custom-table" hover striped>
            <thead className="position-sticky top-0 z-1">
            <tr>
              <th className="text-center" style={{ width: 45 }}>
                Sr.
              </th>
              <th>User</th>
              <th>Role</th>
              <th>Notifications Raised</th>
            </tr>
          </thead>
          <tbody>
            {userActivity?.map((item, index) => (
              <tr key={index}>
                <td className="text-center">{index + 1}</td>
                <td>{item?.generatedBy}</td>
                <td>{item?.studyRole}</td>
                <td>{item?.notificationRaised}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      }
    </>
  );
};

export default UserActivityLogsData;
